import React from 'react';
import { siteConfig } from '../data/works';

const Hero = ({ scrollY }) => {
  return (
    <section style={{
      height: '100vh',
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: `url(${siteConfig.heroImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        transform: `translateY(${scrollY * 0.3}px) scale(${1 + scrollY * 0.0002})`,
        willChange: 'transform'
      }} />
      
      {/* Vignette */}
      <div style={{
        position: 'absolute',
        inset: 0,
        boxShadow: 'inset 0 0 150px 80px rgba(255,255,255,0.95)',
        pointerEvents: 'none'
      }} />
      
      {/* Scroll indicator */}
      <div style={{
        position: 'absolute',
        bottom: '32px',
        left: '50%',
        transform: 'translateX(-50%)',
        opacity: Math.max(0, 1 - scrollY * 0.01),
        transition: 'opacity 0.3s ease'
      }}>
        <div style={{
          width: '1px',
          height: '48px',
          backgroundColor: '#000'
        }} />
      </div>
    </section>
  );
};

export default Hero;
